import EllipsisTypography from './ellipsis-typography-style'
export default EllipsisTypography
